/**
 * Cleans a raw bank description into a standardized Payee name.
 * Removes dates, transaction IDs, and extra whitespace.
 */
export const cleanPayee = (desc) => {
  if (!desc) return '';
  let clean = desc.toUpperCase();
  
  // Remove dates (MM/DD, MM-DD, YYYY-MM-DD)
  clean = clean.replace(/\d{1,4}[/-]\d{1,2}([/-]\d{1,4})?/g, '');
  
  // Remove address suffix (State + Zip)
  clean = clean.replace(/\s[A-Z]{2}\s\d{5}(-\d{4})?$/g, '');
  
  // Remove transaction IDs and common separators (#, *, space + long digits)
  clean = clean.replace(/(#|\*|\s)\d{4,}.*$/g, '');
  
  // Remove extra spaces
  clean = clean.replace(/\s\s+/g, ' ').trim();
  
  // Remove trailing single characters, digits, or connector symbols (e.g., " V", " 2", " -")
  clean = clean.replace(/\s+([A-Z0-9]|-)\b$/g, '').trim();
  clean = clean.replace(/[^A-Z0-9]+$/g, '').trim();

  // Fallback: If clean name is too short, just take first two words of original
  if (clean.length < 2) {
    clean = desc.split(' ').slice(0, 2).join(' ').toUpperCase();
  }
  
  return clean;
};

/**
 * Formats a number as a currency string.
 * @param {number} amount - The numeric value to format.
 * @param {boolean} showSymbol - Whether to include the $ symbol.
 */
export const formatCurrency = (amount, showSymbol = true) => {
  let val = amount || 0;
  // If the value rounds to 0.00, force it to positive 0 to prevent displaying as -0.00 or -$0.00
  if (Math.abs(val) < 0.005) {
    val = 0;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: showSymbol ? 'currency' : 'decimal',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  
  return formatter.format(val);
};

/**
 * Formats a Date string into a UTC MM/DD/YYYY string without timezone offsets.
 * @param {string} dateStr - ISO Date string.
 */
export const formatUtcDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  const parts = dateStr.slice(0, 10).split('-');
  if (parts.length === 3) {
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  }
  return new Date(dateStr).toLocaleDateString();
};

